<template>
  <div class="sort-by-container">
    <p class="sort-title">{{ $t('main.searchResult.searchHeader.sortBy') }}</p>
    <div v-click-outside="() => toggleDropdown(false)" class="position-relative">
      <Button
        color=""
        size="small-medium"
        font-color="#737373"
        shape="outline-hover"
        hover="exp"
        @click="() => toggleDropdown(true)"
        >{{ selectedItem.name }}
        <Icon
          class="ml-1"
          :class="showDropdown ? 'invert-270' : 'invert-90'"
          icon="arrow"
          color="#737373"
          :width="12"
          :height="12"
        />
      </Button>
      <div v-if="showDropdown" class="dropdown-container">
        <div
          v-for="(item, index) in itemList"
          :key="index"
          class="sort-item"
          @click.prevent="selectItem($event, item)"
        >
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from 'UI/Button';
import Icon from 'UI/Icon';
import { mapGetters } from 'vuex';

export default {
  components: {
    Button,
    Icon
  },
  props: {
    sort: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      showDropdown: false,
      itemList: [
        { value: 'latest', name: this.$t('main.searchResult.searchHeader.latest') },
        { value: undefined, name: this.$t('main.searchResult.searchHeader.mostRelevant') }
      ],
      selectedItem: {}
    };
  },
  computed: {
    ...mapGetters('searchBar', ['getActualSearch']),
    ...mapGetters('dimensions', ['getActualDimension']),
    ...mapGetters('search', ['getQuery']),
    query() {
      return { ...this.$route.query, ...this.getQuery };
    }
  },
  created() {
    const myParam = this.$route.query.sort;
    this.selectedItem = this.itemList[myParam ? 0 : 1];
    this.setSortBySelectedItem();
  },
  methods: {
    setSortBySelectedItem() {
      const sort = this.selectedItem.value;
      let query = { ...this.query };
      if (sort) query = { ...query, sort };
      else delete query.sort;
      this.$store.commit('search/SET_QUERY', query);
    },
    async selectItem(el, item) {
      this.$dataLayerPush('click_sort_by', {
        sortBy: {
          sortByOption: item.name
        }
      });
      this.toggleDropdown();
      if (item.value !== this.selectedItem.value) {
        this.selectedItem = item;
        this.setSortBySelectedItem();

        const url = this.$urlBuilder('search', {
          path: this.getActualDimension.path,
          keyword: this.getActualSearch || '',
          page: 1
        });

        const routeQuery = this.$route.query;
        const sort = item.value;
        let query = { ...routeQuery };
        if (sort) query = { ...query, sort };
        else delete query.sort;
        await this.$router.replace({ path: url, query });
        const searchParams = {
          criteria: this.getActualSearch,
          page: 1
        };
        this.$store.dispatch('search/MAKE_SEARCH', searchParams);
      }
    },
    toggleDropdown(value) {
      this.showDropdown = value ? !this.showDropdown : false;
    }
  }
};
</script>

<style lang="scss" scoped>
.sort-by-container {
  font-size: 14px;
  display: flex;
  color: $strongGray;
  .sort-title {
    margin: auto 10px;
    margin-left: 0;
    display: flex;
  }
  .invert-90 {
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    transform: rotate(90deg);
  }
  .invert-270 {
    -webkit-transform: rotate(270deg);
    -moz-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    -o-transform: rotate(270deg);
    transform: rotate(270deg);
  }
  .dropdown-container {
    display: flex;
    flex-wrap: wrap;
    width: max-content;
    position: absolute;
    top: 45px;
    right: 0;
    z-index: 10;
    border-radius: 5px;
    background: white;
    border-radius: 6px;
    flex-direction: column;
  }
  .sort-item {
    z-index: 10;
    border: 2px solid #e6e6e6;
    border-top: none;
    border-bottom: none;
    padding: 7px 10px;
    cursor: pointer;
    &:first-child {
      border-radius: 6px 6px 0 0;
      border-top: 2px solid #e6e6e6;
      padding-top: 9px;
      &:hover {
        border-top: 2px solid $defaultColor;
      }
    }
    &:last-child {
      border-radius: 0 0 6px 6px;
      border-bottom: 2px solid #e6e6e6;
      padding-bottom: 9px;

      &:hover {
        border-bottom: 2px solid $defaultColor;
      }
    }
    &:hover {
      background: $defaultColor;
      color: white;
      border: 2px solid $defaultColor;
      border-top: none;
      border-bottom: none;
    }
  }
}
</style>
